import { createModel } from "hox";
import { useState, useEffect, Key } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import useGlobalModel from "@/model/globalModel";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { IStockStatisticSearch, IStockStatisticDetail, stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import {
    IItemDetailList,
    IMaterialDetailList,
    IMaintenanceField,
    IMaintenanceDetail,
    IMaintenanceRoSettleParams,
    ISettleDetails
} from "../../maintenanceType"
import { maintenanceService } from "../../maintenanceService"
import { IItemDetail, IItemSearch } from "@/views/base/item/itemType";
import { ISearchPage } from "@/types/ScmTypes";
import { itemService } from "@/views/base/item/itemService";
import { transPgToPagination, formatNum, repairFormatNum, bigNumber, IsUseDefaultBentity, momentFormat } from "@/utils/utils";
import { globalPrompt } from "@/components/message";
import { IVehicleDetail } from "@/views/base/customerFiles/vehicle/vehicleType";
import moment from "moment";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { useLockFn } from "ahooks";
import { IServiceNatureCodeType } from "@/types/ScmEnums";
import { message } from "antd";
import { IPurchaseStock } from "@/views/sale/order/saleOrderTypes"
import { saleOrderService } from "@/views/sale/order/saleOrderService"
import { useDictModel } from "@/views/base/dict/dictModel";

export type IMaintenanceDescType = {
    workHours: number, //工时
    workHoursNum: number, //工时项数
    workHoursPrice: number, //工时费 折前
    workHoursDiscount: number, //工时优惠
    workHoursTotal: number, //工时总计 折后
    partPrice: number, //零件费 折前
    partPriceNum: number, //零件费项数
    partsDiscount: number, //零件优惠
    partsTotal: number, //零件总计 折后
    discountAll: number,//优惠金额
    receivableAll: number,//实收金额
    totalAll: number, //总计        

}

//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IPurchaseStock {
    num: number,
    price?: number,
    discountRate?: number,
    amount?: number | string
}
export interface ICustomerAccBillInfo {
    accountName?: string
    availableAmount: number
    isBill?: boolean
}
export const useMaintenanceDetailsModel = createModel(function () {
    const { shopAndOrg, user, beShopDs } = useGlobalModel()
    const { shopId, shopName } = shopAndOrg
    const [itemModel, setItemModel] = useState<boolean>(false); //维修项目弹框
    const [materialModel, setMaterialModel] = useState<boolean>(false); //维修项目弹框 
    const [settleVisible, setSettleVisible] = useState<boolean>(false);   //结算弹框
    const [finalVisible, setFinalVisible] = useState<boolean>(false);   //结算弹框
    const [threeServiceModal, setThreeServiceModal] = useState<boolean>(false);   //三包信息弹框
    const { getSelectedDictOne } = useDictModel();
    const initDesc: IMaintenanceDescType = {
        workHours: 0, //工时
        workHoursNum: 0, //工时项数
        workHoursPrice: 0, //工时费 折前
        workHoursDiscount: 0, //工时优惠
        workHoursTotal: 0, //工时总计 折后
        partPrice: 0, //零件费 折前
        partPriceNum: 0, //零件费项数
        partsDiscount: 0, //零件优惠
        partsTotal: 0, //零件总计 折后
        discountAll: 0,//优惠金额
        receivableAll: 0,//实收金额
        totalAll: 0, //总计    
    }
    const initForm = {
        shopId,
        shopName,
        favorableAmount: 0,
        enterTime: moment(new Date()),
        // bentityCode: IsUseDefaultBentity(shopId) ? DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE : "",
        // bentityName: IsUseDefaultBentity(shopId) ? beShopDs.find(item => item.value === DictCodeEnmu.BENTITY_BJ_YH_AUTO_SERVICE)?.label : ""
        priceTypeName: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION).find((item: any) => item.value === "price-selection.retail")?.label ?? "",
        priceTypeCode: "price-selection.retail",
        settlementPartyName: "客户自费",
        settlementPartyCode: "settle-party.self-pay",
        payTypeName: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE).find((item: any) => item.value === "settle-type.credit")?.label ?? "",
        payType: "settle-type.credit",
        bentityName: beShopDs.find((item: any) => item.value === "bentity.hd")?.label ?? "",
        bentityCode: "bentity.hd",
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initMaterialSearchParam: IStockStatisticSearch = { age: 1 };
    const [vehicleEditAll, setVehicleEditAll] = useState<IVehicleDetail[]>([])//实时切换车辆 编辑
    const [vehicleAddAll, setVehicleAddAll] = useState<IVehicleDetail[]>([])//实时切换车辆 新增

    const [customerAccBillInfo, setCustomerAccBillInfo] = useState<ICustomerAccBillInfo>({ accountName: "", availableAmount: 0, isBill: false })
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IMaintenanceDetail>(initForm)
    //新增项目详情列表
    const [detailItemAddList, setDetailItemAddList] = useState<IItemDetailList[]>([])
    //新增项目详情列表选中行
    const [detailItemAddDataRowKeys, setDetailItemAddDataRowKeys] = useState<Key[]>([]);
    const [detailItemAddDataRow, setDetailItemAddDataRow] = useState<IItemDetailList[]>([]);
    //新增维修用料详情列表
    const [detailMaterialAddList, setDetailMaterialAddList] = useState<IMaterialDetailList[]>([])
    //新增维修用料详情列表选中行
    const [detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys] = useState<Key[]>([]);
    const [detailMaterialAddDataRow, setDetailMaterialAddDataRow] = useState<IMaterialDetailList[]>([]);
    //新增项目详情列表
    const [detailSBItemAddList, setDetailSBItemAddList] = useState<any[]>([])
    //新增项目详情列表选中行
    const [detailSBItemAddDataRowKeys, setDetailSBItemAddDataRowKeys] = useState<Key[]>([]);
    const [detailSBItemAddDataRow, setDetailSBItemAddDataRow] = useState<any>([]);
    const [addDesc, setAddDesc] = useState<IMaintenanceDescType>(initDesc)

    //编辑数据
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IMaintenanceDetail>({})
    //编辑项目详情列表
    const [detailItemEditList, setDetailItemEditList] = useState<IItemDetailList[]>([])
    //编辑项目详情列表选中行
    const [detailItemEditDataRowKeys, setDetailItemEditDataRowKeys] = useState<Key[]>([]);
    const [detailItemEditDataRow, setDetailItemEditDataRow] = useState<IItemDetailList[]>([]);
    //编辑维修用料详情列表
    const [detailMaterialEditList, setDetailMaterialEditList] = useState<IMaterialDetailList[]>([])
    //编辑维修用料详情列表选中行
    const [detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys] = useState<Key[]>([]);
    const [detailMaterialEditDataRow, setDetailMaterialEditDataRow] = useState<IMaterialDetailList[]>([]);
    const [editDesc, setEditDesc] = useState<IMaintenanceDescType>(initDesc)
    const [detailSBItemEditList, setDetailSBItemEditList] = useState<any[]>([])
    //编辑项目详情列表选中行
    const [detailSBItemEditDataRowKeys, setDetailSBItemEditDataRowKeys] = useState<Key[]>([]);
    const [detailSBItemEditDataRow, setDetailSBItemEditDataRow] = useState<any[]>([]);
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IMaintenanceDetail>({})
    //查看项目详情列表
    const [detailItemLookList, setDetailItemLookList] = useState<IItemDetailList[]>([])
    //查看维修用料详情列表
    const [detailMaterialLookList, setDetailMaterialLookList] = useState<IMaterialDetailList[]>([])
    //查看项目详情列表
    const [detailSBItemLookList, setDetailSBItemLookList] = useState<any[]>([])
    const [lookDesc, setLookDesc] = useState<IMaintenanceDescType>(initDesc)
    //查看结算详情
    const [lookSettleDetails, setLookSettleDetails] = useState<ISettleDetails[]>([])
    //配件列表配置
    const [workMaterialDataSource, setWorkMaterialDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkMaterialData, setSearchWorkMaterialData] = useState<IStockStatisticSearch>(initMaterialSearchParam)
    const [workMaterialPgCfg, setWorkMaterialPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataMaterialSource, setAddDataMaterialSource] = useState<any[]>([]);
    //编辑结算详情
    const [editSettleDetails, setEditSettleDetails] = useState<ISettleDetails[]>([])
    //维修项目列表配置
    const [workItemDataSource, setWorkItemDataSource] = useState<IItemDetail[]>([])
    const [searchWorkItemData, setSearchWorkItemData] = useState<IItemSearch>(initMaterialSearchParam)
    const [workItemPgCfg, setWorkItemPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选维修项目列表
    const [addDataItemSource, setAddDataItemSource] = useState<IItemDetail[]>([]);
    const [saveLoading, setSaveLoading] = useState<boolean>(false); //  保存按钮
    const [popupMode, setPopupMode] = useState<string>("");
    const [SBcode, setSBcode] = useState<any>(null)
    useEffect(() => {
        setDetailAddForm({ ...initForm, shopId, shopName });
    }, [shopId])
    //表单改变或表格数据发生改变时，控制功能按钮的启用禁用
    const [topButsControl, setTopButsControl] = useState<boolean>(false)
    //重复的最近维修项目
    const [duplicateItems, setDuplicateItems] = useState<any[]>([]);
    const [isThreeService, setIsThreeService] = useState<boolean>(false);

    useEffect(() => {
        let newDesc: IMaintenanceDescType = { ...initDesc };
        detailItemAddList && detailItemAddList.forEach((item) => {
            newDesc.workHours += Number(item.workHour)
            //newDesc.workHoursPrice += Number(item.itemAmount)
            newDesc.workHoursPrice = bigNumber.add(newDesc.workHoursPrice, item.itemAmount as number)
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount)
            newDesc.workHoursTotal += Number(item.receivableAmount);
        })
        detailMaterialAddList && detailMaterialAddList.forEach((item) => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount);
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = bigNumber.add(newDesc.workHoursTotal, newDesc.partsTotal)
        newDesc.workHoursNum = detailItemAddList.length
        newDesc.partPriceNum = detailMaterialAddList.length
        if ("favorableAmount" in detailAddForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailAddForm.favorableAmount)
            newDesc.receivableAll = newDesc.receivableAll - Number(detailAddForm.favorableAmount)
        }
        setAddDesc(newDesc);
    }, [detailItemAddList, detailMaterialAddList, detailAddForm])
    useEffect(() => {
        let newDesc: IMaintenanceDescType = { ...initDesc };
        detailItemEditList && detailItemEditList.forEach((item) => {
            newDesc.workHours += Number(item.workHour)
            //newDesc.workHoursPrice += Number(item.itemAmount)
            newDesc.workHoursPrice = bigNumber.add(newDesc.workHoursPrice, item.itemAmount as number)
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount)
            newDesc.workHoursTotal += Number(item.receivableAmount);
        })
        detailMaterialEditList && detailMaterialEditList.forEach((item) => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount);
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = bigNumber.add(newDesc.workHoursTotal, newDesc.partsTotal)
        newDesc.workHoursNum = detailItemEditList.length
        newDesc.partPriceNum = detailMaterialEditList.length
        if ("favorableAmount" in detailEditForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailEditForm.favorableAmount)
            newDesc.receivableAll = newDesc.receivableAll - Number(detailEditForm.favorableAmount)
        }
        setEditDesc(newDesc);
        // setTopButsControl(true)
    }, [detailItemEditList, detailMaterialEditList, detailEditForm])
    useEffect(() => {
        let newDesc: IMaintenanceDescType = { ...initDesc };
        detailItemLookList && detailItemLookList.forEach((item) => {
            newDesc.workHours += Number(item.workHour)
            //newDesc.workHoursPrice += Number(item.itemAmount)
            newDesc.workHoursPrice = bigNumber.add(newDesc.workHoursPrice, item.itemAmount as number)
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount)
            newDesc.workHoursTotal += Number(item.receivableAmount);
        })
        detailMaterialLookList && detailMaterialLookList.forEach((item) => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount);
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = bigNumber.add(newDesc.workHoursTotal, newDesc.partsTotal)
        newDesc.workHoursNum = detailItemLookList.length
        newDesc.partPriceNum = detailMaterialLookList.length
        if ("favorableAmount" in detailLookForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount)
            newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount)
        }
        setLookDesc(newDesc);
    }, [detailItemLookList, detailMaterialLookList, detailLookForm])

    //新增表单缓存
    const updateAddFormVal = (val: IMaintenanceDetail) => {
        let newVal = val
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updateEditFormVal = (val: IMaintenanceDetail) => {
        let newVal = val
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }

    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await maintenanceService.one(id);
        const { itemDetails, threeGuarantees, settleDetails, materialDetails, deliveryTime, enterTime, finalTime, ...from } = retData
        const newItemDetails = itemDetails?.map((item) => {
            return {
                ...item,
                detailsId: item.id,
            }
        })
        const newMaterialDetails = materialDetails?.map((item) => {
            return {
                ...item,
                detailsId: item.id,
                termNum: Number(item.num) + Number(item.inventoryNum) //判断编辑数量的条件
            }
        })
        const splitFields = from.msg?.split("|") ?? [];
        const newFrom = {
            ...from,
            fileMsg: from.fileMsg ? from.fileMsg.split(",") : [],
            finalMsg: from.finalMsg ? from.finalMsg.split(",") : [],
            msg1: splitFields?.length > 0 ? splitFields[0] : "",
            msg2: splitFields?.length > 1 ? splitFields[1] : "",
            enterTime: enterTime ? moment(enterTime) : null,
            finalTime: finalTime ? momentFormat(finalTime) : null,
            deliveryTime: deliveryTime ? moment(deliveryTime) : null
        }
        if (retData && pattern === "edit") {
            setDetailItemEditList(newItemDetails as IItemDetailList[] ?? [])
            setDetailMaterialEditList(newMaterialDetails as IMaterialDetailList[] ?? [])
            setDetailSBItemEditList(threeGuarantees as any[] ?? [])
            setDetailEditForm(newFrom)
            setTopButsControl(false)
            setEditSettleDetails(settleDetails as ISettleDetails[] ?? [])
        } else if (retData && pattern === "look") {
            setDetailLookForm(newFrom);
            setDetailItemLookList(newItemDetails as IItemDetailList[] ?? [])
            setDetailSBItemLookList(threeGuarantees as any[] ?? [])
            setDetailMaterialLookList(newMaterialDetails as IMaterialDetailList[] ?? [])
            setLookSettleDetails(settleDetails as ISettleDetails[] ?? [])
        }
    }
    //关闭维修项目弹框
    const resetWorkItemloadData = async () => {
        setSearchWorkItemData({});
        workItemloadData(initPgCfg, {});
    }
    const workItemloadData = async (page?: ISearchPage, searchValue: IItemSearch = searchWorkItemData) => {
        const searchParams = {
            ...shopAndOrg,
            ...searchValue,
            pageSize: page?.pageSize ?? workItemPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workItemPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            enable: 1,
        }
        let { retData } = await itemService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                num: 1,
                code: item.itemCode,
                name: item.itemName,
                workHours: item.itemWorkHours,
                price: item.workHoursPrice,
                amount: item.itemAmount,
            }
        })
        setWorkItemPgCfg(transPgToPagination(pg));
        setWorkItemDataSource(newRecords);
    }
    //保存三包信息
    const saveThreeServiceInfo = async (values: any, mode: string, popupMode?: string) => {
        try {
            console.log("保存三包信息:", values, "模式:", mode, "弹框模式:", popupMode);
            if (popupMode === 'add') {
                const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                const newThreeService = { ...values, tempId };
                if (mode === 'add') {
                    setDetailSBItemAddList(prev => [...prev, newThreeService]);
                } else if (mode === 'edit') {
                    setDetailSBItemEditList(prev => [...prev, newThreeService]);
                }
            } else if (popupMode === 'edit') {
                const updatedThreeService = { ...values };
                setDetailSBItemEditList(prev =>
                    prev.map(item => item.id === SBcode ? updatedThreeService : item)
                );
                // 合并项目到主单据物料列表
                if (values.materialList && values.materialList.length > 0) {
                    setDetailMaterialEditList(prev => {
                        const newList = [...prev];
                        values.materialList.forEach((newMaterial: any) => {
                            // 以 materialCode + purchaseCode 为唯一键
                            const index = newList.findIndex(existing =>
                                existing.materialCode === newMaterial.materialCode &&
                                existing.purchaseCode === newMaterial.purchaseCode
                            );
                            if (index !== -1) {
                                const existing = newList[index];
                                newList[index] = { ...existing, ...newMaterial };
                            } else {
                                newList.push({ ...newMaterial });
                            }
                        });
                        return newList;
                    });
                }

                // 合并项目到主单据项目列表
                if (values.itemList && values.itemList.length > 0) {
                    setDetailItemEditList(prev => {
                        const newList = [...prev];
                        values.itemList.forEach((newItem: any) => {
                            const index = newList.findIndex(existing =>
                                existing.itemCode === newItem.code ||
                                existing.itemCode === newItem.itemCode
                            );
                            if (index !== -1) {
                                const existing = newList[index];
                                newList[index] = { ...existing, ...newItem };
                            } else {
                                newList.push({ ...newItem });
                            }
                        });
                        return newList;
                    });
                }

                // 项目列表在三包弹框内可能也需要维护，根据需求决定是否更新
                if (values.itemList && values.itemList.length > 0) {
                    console.log("更新维修项目数据:", values.itemList);
                }
            }

            message.success("保存成功");
            return true;
        } catch (error) {
            console.error("保存三包信息失败:", error);
            message.error("保存失败");
            return false;
        }
    };
    //关闭维修用料弹框
    const resetWorkMaterialloadData = async () => {
        setSearchWorkMaterialData({});
        workMaterialloadData(initPgCfg, {});
    }
    const workMaterialloadData = async (page?: ISearchPage, searchValue: IStockStatisticSearch = searchWorkMaterialData, mode?: string) => {
        const searchParams = {
            ...searchValue,
            // ...shopAndOrg,
            ...sourceAppOrBranch,
            shopName: detailEditForm?.shopName ?? detailAddForm?.shopName,
            shopId: detailEditForm?.shopId ?? detailAddForm?.shopId,
            shopType: "1",
            status: `${DictCodeEnmu.PURCHASE_STATUS_BILL},${DictCodeEnmu.PURCHASE_STATUS_COMPLETELY_IO},${DictCodeEnmu.PURCHASE_STATUS_ALLOCATION}`,
            pageSize: page?.pageSize ?? workMaterialPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workMaterialPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleOrderService.stock(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                num: 1,
            }
        })
        setWorkMaterialPgCfg(transPgToPagination(pg));
        setWorkMaterialDataSource(newRecords);
    }

    //添加到维修用料详情列表
    const transformsToPoMaterialDetailList = (mode: string, selectedList = addDataMaterialSource) => {
        let detailList = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const repetition: string[] = [];
        const newDetailData: IMaterialDetailList[] = []
        selectedList.forEach(Item => {
            let isSelect = detailList?.find(item => item.materialCode === Item.materialCode && item.purchaseCode === Item.purchaseCode);
            let { id, materialCode, materialName, inventoryNum, availableStock, num, price, discountRate, ...params } = Item
            discountRate = +(discountRate ?? 100)
            price = + (price ?? 0)
            if (!isSelect||isSelect.status === 'details.preparation.ware.out') {
                newDetailData.push({
                    ...params,
                    discountRate,
                    id: "",
                    inventoryNum: availableStock,
                    // termNum:availableStock,
                    materialCode,
                    materialName,
                    num,
                    price,
                    lateSalePrice: price,
                    materialAmount: +formatNum(num * price),
                    // materialAmount:+bigNumber.toFixed(bigNumber.times(num,price),3),
                    discountedAmount: +formatNum((num * price * discountRate) / 100),
                    // discountedAmount:+bigNumber.toFixed(bigNumber.dividedBy(bigNumber.times(bigNumber.times(num,price),discountRate),100),3),
                    receivableAmount: +formatNum((num * price * discountRate) / 100),
                    // receivableAmount:+bigNumber.toFixed(bigNumber.dividedBy(bigNumber.times(bigNumber.times(num,price),discountRate),100),3),
                    decreaseAmount: 0,//单项优惠默认0
                    stockId: id,
                    detailsId: id,
                    purchaseId: id,
                    status: "",
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        });
        (mode === "edit" ? setDetailMaterialEditList : setDetailMaterialAddList)([...detailList, ...newDetailData])
        repetition.length !== 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，采购单号相同，重复的将不在添加。`, type: "warning" });
    }

    //删除维修用料详情列表数据
    const detailMaterialDetailList = async (mode: string, Material?: IMaterialDetailList) => {
        if (mode === "add") {
            // const filterDetailList = detailMaterialAddList.filter(el => !!!detailMaterialAddDataRowKeys.find(ele => ele === el.detailsId))
            const filterDetailList = Material ? detailMaterialAddList.filter(el => !!!(Material.detailsId === el.detailsId)) : detailMaterialAddList.filter(el => !!!detailMaterialAddDataRowKeys.find(ele => ele === el.detailsId));
            setDetailMaterialAddList(filterDetailList)
            globalPrompt("message", { text: `删除成功`, type: "success" });
            setDetailMaterialAddDataRowKeys([]);
            setDetailMaterialAddDataRow([]);
        }
        else if (mode === "edit") {
            // const filterDetailList = detailMaterialEditList.filter(el => !!!detailMaterialEditDataRowKeys.find(ele => ele === el.detailsId))
            const filterDetailList = Material ? detailMaterialEditList.filter(el => !!!(Material.detailsId === el.detailsId)) : detailMaterialEditList.filter(el => !!!detailMaterialEditDataRowKeys.find(ele => ele === el.detailsId));
            setDetailMaterialEditList(filterDetailList)
            globalPrompt("message", { text: `删除成功,保存后生效！`, type: "success" });
            setDetailMaterialEditDataRowKeys([]);
            setDetailMaterialEditDataRow([]);
        }
        // else if (mode === "edit") {
        //     const backendDetailList: any = Material ? Material.id ? [{ id: Material.id }] : [] : detailMaterialEditDataRow.reduce((all: object[], next) => {  //前端页面维护的需要删除的id
        //         if (next.id) {
        //             all.push({ id: next.id });
        //         }
        //         return all;
        //     }, [])

        //     //删除详情列表调用的方法
        //     const deleteData = () => {
        //         const filterDetailList = Material ? detailMaterialEditList.filter(el => !!!(Material.detailsId === el.detailsId)) : detailMaterialEditList.filter(el => !!!detailMaterialEditDataRowKeys.find(ele => ele === el.detailsId))
        //         // const filterDetailList = detailMaterialEditList.filter(el => !!!detailMaterialEditDataRowKeys.find(ele => ele === el.detailsId))
        //         setDetailMaterialEditList(filterDetailList)
        //         globalPrompt("message", { text: `删除成功`, type: "success" });
        //         setDetailMaterialEditDataRowKeys([]);
        //         setDetailMaterialEditDataRow([]);
        //     }

        //     if (backendDetailList.length > 0) {
        //         await maintenanceService.materialDelete({ ids: backendDetailList, maintenanceCode: detailEditForm.maintenanceCode as string }).then(res => {
        //             if (res.retData) {
        //                 deleteData()
        //             } else {
        //                 globalPrompt("message", { text: `删除失败`, type: "success" });
        //             }
        //         })
        //     } else {
        //         deleteData()
        //     }
        // }
    }

    //筛选维修项目模块详情 详情和新增的列表已有数据的方法
    const modelItemScreenMethod = async (modelList: IItemDetail[], detailList: IItemDetailList[]) => {
        const repetition: string[] = [];
        const newDetailData: IMaterialDetailList[] = []
        modelList.forEach(Item => {
            let isSelect = detailList && detailList.find(item => item.itemCode === Item.code);
            let { code, name, id, amount, price, workHours, ...params } = Item;
            if (isSelect === undefined) {
                newDetailData.push({
                    ...params,
                    id: "",
                    detailsId: id,
                    discountRate: 100,
                    itemAmount: amount,
                    itemCode: code,
                    itemName: name,
                    price: price,
                    receivableAmount: amount,
                    workHour: workHours

                });
            } else {
                repetition.push(Item.name as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到维修项目详情列表
    const transformsToPoItemDetailList = async (mode: string) => {
        //添加列表
        if (mode === "add") {
            const { repetition, newDetailData } = await modelItemScreenMethod(addDataItemSource, detailItemAddList)
            setDetailItemAddList([...detailItemAddList, ...newDetailData])
            repetition.length !== 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            recentItems(mode, [...detailItemAddList, ...newDetailData]);
        }
        else if (mode === "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelItemScreenMethod(addDataItemSource, detailItemEditList)
            setDetailItemEditList([...detailItemEditList, ...newDetailData])
            repetition.length !== 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            recentItems(mode, [...detailItemEditList, ...newDetailData]);
        }
    }
    //删除维修项目详情列表数据
    const detailItemDetailList = async (mode: string, Item?: IItemDetailList) => {
        if (mode === "add") {
            const filterDetailList = Item ? detailItemAddList.filter(el => !!!(Item.detailsId === el.detailsId)) : detailItemAddList.filter(el => !!!detailItemAddDataRowKeys.find(ele => ele === el.detailsId));
            // const filterDetailList = detailItemAddList.filter(el => !!!detailItemAddDataRowKeys.find(ele => ele === el.detailsId))
            setDetailItemAddList(filterDetailList)
            globalPrompt("message", { text: `删除成功`, type: "success" });
            setDetailItemAddDataRowKeys([]);
            setDetailItemAddDataRow([]);
        }
        else if (mode === "edit") {
            const filterDetailList = Item ? detailItemEditList.filter(el => !!!(Item.detailsId === el.detailsId)) : detailItemEditList.filter(el => !!!detailItemEditDataRowKeys.find(ele => ele === el.detailsId));
            // const filterDetailList = detailItemEditList.filter(el => !!!detailItemEditDataRowKeys.find(ele => ele === el.detailsId))
            setDetailItemEditList(filterDetailList)
            globalPrompt("message", { text: `删除成功,保存后生效！`, type: "success" });
            setDetailItemEditDataRowKeys([]);
            setDetailItemEditDataRow([]);
        }
        // else if (mode === "edit") {
        //     const backendDetailList: any = Item ? [{ id: Item.id }] : detailItemEditDataRow.reduce((all: object[], next) => {  //前端页面维护的需要删除的id
        //         if (next.id) {
        //             all.push({ id: next.id });
        //         }
        //         return all;
        //     }, []);

        //     //删除详情列表调用的方法
        //     const deleteData = () => {
        //         // const filterDetailList = detailItemEditList.filter(el => !!!detailItemEditDataRowKeys.find(ele => ele === el.detailsId));
        //         const filterDetailList = Item ? detailItemEditList.filter(el => !!!(Item.detailsId === el.detailsId)) : detailItemEditList.filter(el => !!!detailItemEditDataRowKeys.find(ele => ele === el.detailsId))
        //         setDetailItemEditList(filterDetailList)
        //         globalPrompt("message", { text: `删除成功`, type: "success" });
        //         setDetailItemEditDataRowKeys([]);
        //         setDetailItemEditDataRow([]);
        //     }

        //     if (backendDetailList.length > 0) {
        //         await maintenanceService.itemDelete({ ids: backendDetailList, maintenanceCode: detailEditForm.maintenanceCode as string }).then(res => {
        //             if (res.retData) {
        //                 deleteData()
        //             } else {
        //                 globalPrompt("message", { text: `删除失败`, type: "success" });
        //             }
        //         })
        //     } else {
        //         deleteData()
        //     }
        // }
    }

    //删除三包信息详情列表数据
    const detailSBItemDetailList = async (mode: string, SBItem?: any) => {
        const getRowKey = (item: any) => item.tempId || item.id;
        if (mode === "add") {
            const filterDetailList = SBItem ? detailSBItemAddList.filter(el => !((SBItem.tempId || SBItem.id) === getRowKey(el))) : detailSBItemAddList.filter(el => !detailSBItemAddDataRowKeys.find(ele => ele === getRowKey(el)));
            setDetailSBItemAddList(filterDetailList)
            globalPrompt("message", { text: `删除成功`, type: "success" });
            setDetailSBItemAddDataRowKeys([]);
            setDetailSBItemAddDataRow([]);
        }
        else if (mode === "edit") {
            const filterDetailList = SBItem ? detailSBItemEditList.filter(el => !((SBItem.tempId || SBItem.id) === getRowKey(el))) : detailSBItemEditList.filter(el => !detailSBItemEditDataRowKeys.find(ele => ele === getRowKey(el)));
            setDetailSBItemEditList(filterDetailList)
            globalPrompt("message", { text: `删除成功,保存后生效！`, type: "success" });
            setDetailSBItemEditDataRowKeys([]);
            setDetailSBItemEditDataRow([]);
        }
    }

    //表单计算校验 (计算主单信息与配件每一项)
    const formComputeRule = (mode: string) => {
        let goods = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        let item = mode === "edit" ? detailItemEditList : detailItemAddList;

        if (item.length === 0 && !isThreeService) {
            message.warning(`请补全单据的维修项目！`);
            return false;
        }
        return true
        // let { favorableAmount } = (mode === "edit" ? detailEditForm : detailAddForm) as { favorableAmount: number };
        // let { workHoursTotal, partsTotal, receivableAll } = mode === "edit" ? editDesc : addDesc;
        // workHoursTotal = +formatNum(workHoursTotal);//工时总计 折后
        // partsTotal = +formatNum(partsTotal);//配件总计 折后
        // receivableAll = +formatNum(receivableAll);
        // favorableAmount = +formatNum(favorableAmount);
        // let goodsTotal: number = 0;
        // let itemsTotal: number = 0;
        // if (goods.length !== 0) {
        //     goods.map(item => {
        //         let { receivableAmount, num } = item as { receivableAmount: number, num: number };
        //         // 优惠后单价  总计 -整单优惠 * (单品总计/sum(单品总计) /开单数量
        //         // let czasd = (receivableAmount/ num-(favorableAmount * (receivableAmount/(partsTotal + favorableAmount))/ num)) * num;
        //         let amountAfter = +bigNumber.toFixed(bigNumber.times(bigNumber.minus(bigNumber.dividedBy(receivableAmount, num), bigNumber.dividedBy(bigNumber.times(favorableAmount, bigNumber.dividedBy(receivableAmount, bigNumber.add(partsTotal, favorableAmount))), num)), num), 3);
        //         goodsTotal += amountAfter; // (receivableAmount / num - (favorableAmount * (receivableAmount / (partsTotal + favorableAmount)) / num)) * num;
        //         item.amountAfter = amountAfter
        //         return item;
        //     })
        //     item.map(item => {
        //         let { receivableAmount } = item as { receivableAmount: number };
        //         itemsTotal += (receivableAmount);
        //         item.amountAfter = receivableAmount
        //         return item;
        //     })
        // } else {
        //     item.map(item => {
        //         let { receivableAmount, workHour } = item as { receivableAmount: number, workHour: number }
        //         // 优惠后单价  总计 -整单优惠 * (单品总计/sum(单品总计) /开单数量
        //         let amountAfter = (receivableAmount / workHour - (favorableAmount * (receivableAmount / (workHoursTotal + favorableAmount)) / workHour)) * workHour;
        //         goodsTotal += amountAfter;
        //         item.amountAfter = amountAfter
        //         return item;
        //     })
        // }
        // // 找出points最大对象所在的索引
        // // var indexOfMax = 0;
        // // var max = a.reduce((a, c, i) => c.points > a ? (indexOfMax = i, c.points) : a, 0)
        // var indexofMax = 0;
        // let actualDifference = receivableAll - (goodsTotal + itemsTotal)
        // if (actualDifference !== 0 && goods.length !== 0) {
        //     // debugger;
        //     let maxItem = goods.reduce((a, c: any, i) => c.receivableAmount > a ? (indexofMax = i, c) : a, {});
        //     goods.splice(indexofMax, 1, { ...maxItem, amountAfter: maxItem.amountAfter + actualDifference });
        // } else if (actualDifference !== 0 && item.length !== 0) {
        //     let maxItem = item.reduce((a, c: any, i) => c.receivableAmount > a ? (indexofMax = i, c) : a, {});
        //     item.splice(indexofMax, 1, { ...maxItem, amountAfter: maxItem.amountAfter + actualDifference });
        // }
        // mode === "add" ? setDetailItemAddList(item) : setDetailItemEditList(item);
        // mode === "add" ? setDetailMaterialAddList(item) : setDetailMaterialEditList(item);
    }
    //新增预约单
    const insertDetail = useLockFn(async (params: IMaintenanceField) => {
        try {
            let str = "";
            let list = detailMaterialAddList.map(item => {
                let { price, latestPurPrice, discountRate, decreaseAmount, num } = item as any;

                if (+(price ?? 0) < +latestPurPrice) {
                    str += `【${item.materialName}】`
                    price = +latestPurPrice;
                    let discountedAmount = params.serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * price * discountRate) / 100) : +formatNum((num * price * discountRate) / 100);
                    return {
                        ...item,
                        price,
                        materialAmount: params.serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * price) : +formatNum(num * price),
                        discountedAmount,
                        receivableAmount: discountedAmount - decreaseAmount
                    }
                }
                return item;
            });
            if (str) {
                str += "以上维修用料的单价不应小于进货价，系统帮您重置成进货价，请重新审核后进行保存";
                setDetailMaterialAddList(list);
                message.warning(str);
                return
            }
            let newParams = {
                ...params,
                ...sourceAppOrBranch,
                createUser: user.username,
                itemDetails: detailItemAddList,
                threeGuarantees: detailSBItemAddList,
                materialDetails: detailMaterialAddList.map(item => {
                    return {
                        ...item,
                        status: ""
                    }
                })
            }
            setSaveLoading(true)
            let { retData } = await maintenanceService.insert(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //编辑预约单
    const editDetail = useLockFn(async (params: IMaintenanceField) => {
        try {
            let str = "";
            let list = detailMaterialEditList.map(item => {
                let { price, latestPurPrice, discountRate, decreaseAmount, num } = item as any;

                if (+(price ?? 0) < +latestPurPrice) {
                    str += `【${item.materialName}】`
                    price = +latestPurPrice;
                    let discountedAmount = params.serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * price * discountRate) / 100) : +formatNum((num * price * discountRate) / 100);
                    return {
                        ...item,
                        price,
                        materialAmount: params.serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * price) : +formatNum(num * price),
                        discountedAmount,
                        receivableAmount: discountedAmount - decreaseAmount
                    }
                }
                return item;
            });
            if (str) {
                str += "以上维修用料的单价不应小于进货价，系统帮您重置成进货价，请重新审核后进行保存";
                setDetailMaterialEditList(list);
                message.warning(str);
                return
            }
            let newParams = {
                ...params,
                ...sourceAppOrBranch,
                updateUser: user.username,
                itemDetails: detailItemEditList,
                threeGuarantees: detailSBItemEditList,
                materialDetails: detailMaterialEditList.map(item => {
                    return {
                        ...item,
                        // status: ""
                    }
                })
            }
            setSaveLoading(true)
            let { retData } = await maintenanceService.update(newParams)
            setSaveLoading(false)
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    })
    //转工单核对
    const transfer = async () => {
        let { appointmentCode, id } = detailEditForm
        let { retData } = await maintenanceService.transfer({ appointmentCode, id })
        return retData
    }
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type?: string) => {
        setDetailAddForm(initForm)
        setDetailItemAddList([]);
        setDetailMaterialAddList([]);
    }
    const resetEditCatch = async (type?: string) => {
        setDetailEditForm({});
        setDetailItemEditList([]);
        setDetailMaterialEditList([]);
    }
    const onSettle = async (paramas: IMaintenanceRoSettleParams) => {
        let { retData } = await maintenanceService.settl(paramas);
        return retData
    }
    const onExamine = async (paramas: object) => {
        let { retData } = await maintenanceService.examine(paramas);
        return retData
    }
    const onApproved = async (paramas: object) => {
        let { retData } = await maintenanceService.approved(paramas);
        return retData
    }
    const onBackExamine = async (paramas: object) => {
        console.log(paramas)
        let { retData } = await maintenanceService.chargebackApproval(paramas);
        return retData
    }
    const onBackApproved = async (paramas: object) => {
        let { retData } = await maintenanceService.chargebackPassed(paramas);
        return retData
    }

    const recentItems = async (mode: string, itemList: IItemDetailList[]) => {
        const form = mode === "add" ? detailAddForm : mode === "edit" ? detailEditForm : null;
        if (form != null) {
            const itemCodeList = itemList.map(e => e.itemCode);
            const params = { licensePlate: form.licensePlate, itemCodeList: itemCodeList };
            let { retData } = await maintenanceService.recentItems(params);
            const recentItems = retData.filter(e => e.maintenanceCode != form.maintenanceCode);
            if (recentItems != null && recentItems?.length > 0) {
                setDuplicateItems(recentItems);
                const time = moment(retData[0].createTime).format('YYYY-MM-DD');
                const items = Array.from(new Set(recentItems.map(e => e.itemCode))).concat();
                globalPrompt("message", { text: "该车（" + time + "）已进行过相同项目" + items + "的维修，请检查是否存在相同问题", type: "warning" });
            }
        }
    }

    const [historyVisible, setHistoryVisible] = useState<boolean>(false)
    const [historyRow, setHistoryRow] = useState<IStockStatisticDetail>({})
    const [consumeHistoryVisible, setConsumeHistoryVisible] = useState<boolean>(false) //消费记录展示
    const [consumeHistoryModel, setConsumeHistoryModel] = useState<{ customerName: string }>({ customerName: "" }) //消费记录参数
    const [repairHistoryVisible, setRepairHistoryVisible] = useState<boolean>(false) //维修历史展示
    const [repairHistoryModel, setRepairHistoryModel] = useState<{ licensePlate: string }>({ licensePlate: "" }) //维修历史
    return {
        initForm,
        itemModel,
        materialModel,
        initPgCfg,
        initMaterialSearchParam,
        detailAddForm,
        detailItemAddList,
        detailItemAddDataRowKeys,
        detailItemAddDataRow,
        detailMaterialAddList,
        detailMaterialAddDataRowKeys,
        detailMaterialAddDataRow,
        addDesc,
        detailEditForm,
        detailItemEditList,
        detailItemEditDataRowKeys,
        detailItemEditDataRow,
        detailMaterialEditList,
        detailMaterialEditDataRowKeys,
        detailMaterialEditDataRow,
        editDesc,
        detailLookForm,
        detailItemLookList,
        detailMaterialLookList,
        lookDesc,
        workMaterialDataSource,
        searchWorkMaterialData,
        workMaterialPgCfg,
        addDataMaterialSource,
        workItemDataSource,
        searchWorkItemData,
        workItemPgCfg,
        addDataItemSource,
        topButsControl,
        popupMode,
        setPopupMode,
        transfer,
        setItemModel,
        setMaterialModel,
        setDetailAddForm,
        setDetailItemAddList,
        setDetailItemAddDataRowKeys,
        setDetailItemAddDataRow,
        setDetailMaterialAddList,
        setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        setAddDesc,
        setDetailEditForm,
        setDetailItemEditList,
        setDetailItemEditDataRowKeys,
        setDetailItemEditDataRow,
        setDetailMaterialEditList,
        setDetailMaterialEditDataRowKeys,
        setDetailMaterialEditDataRow,
        setEditDesc,
        setDetailLookForm,
        setDetailItemLookList,
        setDetailMaterialLookList,
        setLookDesc,
        setWorkMaterialDataSource,
        setSearchWorkMaterialData,
        setWorkMaterialPgCfg,
        setAddDataMaterialSource,
        setWorkItemDataSource,
        setSearchWorkItemData,
        setWorkItemPgCfg,
        setAddDataItemSource,
        setTopButsControl,
        updateAddFormVal,
        updateEditFormVal,
        getDetailEditOne,
        resetWorkItemloadData,
        workItemloadData,
        resetWorkMaterialloadData,
        workMaterialloadData,
        transformsToPoMaterialDetailList,
        detailMaterialDetailList,
        modelItemScreenMethod,
        transformsToPoItemDetailList,
        detailItemDetailList,
        vehicleEditAll, setVehicleEditAll,
        vehicleAddAll, setVehicleAddAll,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        settleVisible, setSettleVisible,
        onSettle,
        historyVisible, setHistoryVisible,
        historyRow, setHistoryRow,
        lookSettleDetails, setLookSettleDetails,
        editSettleDetails, setEditSettleDetails,
        consumeHistoryModel, setConsumeHistoryModel,
        consumeHistoryVisible, setConsumeHistoryVisible,
        repairHistoryModel, setRepairHistoryModel,
        repairHistoryVisible, setRepairHistoryVisible,
        customerAccBillInfo, setCustomerAccBillInfo,
        onExamine,
        onApproved,
        onBackExamine,
        onBackApproved,
        formComputeRule,
        recentItems,
        saveLoading, setSaveLoading,
        duplicateItems, setDuplicateItems,
        finalVisible, setFinalVisible,
        detailSBItemAddList, setDetailSBItemAddList,
        detailSBItemAddDataRowKeys, setDetailSBItemAddDataRowKeys,
        detailSBItemAddDataRow, setDetailSBItemAddDataRow,
        detailSBItemEditList, setDetailSBItemEditList,
        detailSBItemEditDataRowKeys, setDetailSBItemEditDataRowKeys,
        detailSBItemEditDataRow, setDetailSBItemEditDataRow,
        threeServiceModal, setThreeServiceModal,
        saveThreeServiceInfo,
        SBcode, setSBcode,
        isThreeService, setIsThreeService,
        detailSBItemLookList, setDetailSBItemLookList,
        detailSBItemDetailList
    }
})